export default "__VITE_ASSET__d7ccfbfd__"